import { render } from "./QuizQuestionCard.vue?vue&type=template&id=0cd16344"
import script from "./QuizQuestionCard.vue?vue&type=script&lang=js"
export * from "./QuizQuestionCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__